// import AppAvaliacao from "./features/AppAvaliacao/AppAvaliacao";
import PaymentModal from "./features/PaymentModal/PaymentModal";
import Stacking from "./features/PopUpPagamento/Stacking";
// import { useSubMenu } from "./SubMenuContext";
import { useUser } from "./UserContext";
import { DEV } from "./lib/dev";

export { getStatusApp, type StatusApp } from "./lib/statusApp";

type HeadersType = {
    [key: string]: string;
};

const CurrentStoreWrapper = ({ expiredAccountPopUpEnabled = () => true }: { expiredAccountPopUpEnabled?: () => boolean; appEndPoint?: string; headers?: HeadersType }) => {
    const { current_store } = useUser()?.user || {};
    const { hideApps, iframe } = useUser();
    // const { app } = useSubMenu();

    const isAvaliacaoModalOpen = localStorage.getItem('avaliacaoModal');

    // tem q ver oq vai fazer com isso :p
    expiredAccountPopUpEnabled?.();

    return (
        <>
            {hideApps ? <></> : (
                <>
                    {/* Em dev não há loja logada — sem o DEV o Stacking nem montava. */}
                    {(current_store || DEV) && <Stacking />}
                    <>
                        {
                            // iframe ? <></> : <>{!isAvaliacaoModalOpen && <>{current_store && current_store['exibir_box_review'] ? <AppAvaliacao infos={current_store} appEndPoint={appEndPoint} headers={headers} app={app} /> : null}</>}</>
                            iframe ? <></> : <>{!isAvaliacaoModalOpen && <>{current_store && current_store['exibir_box_review'] ? <></> : null}</>}</>
                        }
                    </>
                    {current_store && current_store['link_abrir_modal_pagamento'] ? <PaymentModal link={current_store['link_abrir_modal_pagamento']} /> : null}
                </>
            )}
        </>
    )
};

export default CurrentStoreWrapper;